import { EntityRepository, Repository } from "typeorm";
import { StockLog } from "../stock-log.entity";
import { Stock } from "../stock.entity";

@EntityRepository(StockLog)
export class StockLogRepository extends Repository<StockLog>{
}